import { render, staticRenderFns } from "./VideoEditModal.vue?vue&type=template&id=163397d9&"
import script from "./VideoEditModal.vue?vue&type=script&lang=js&"
export * from "./VideoEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports